export default [
  {
    id: 1,
    avatar: "https://i.pravatar.cc/150?img=1",
    name: "Vansh Saini", // Member Name
    role: "Social Media Strategist", // Member Role
    projectName: "Sky Grid",         // Project Name
    projectRole: "Worked Desk 1",    // Project Role
    currentRate: "No rate set",
    totalHours: '6:18:00', 
    totalAmount: '0.00',
  },
  {
    id: 2,
    avatar: "https://i.pravatar.cc/150?img=2",
    name: "Ansh Jain",
    role: "UI/UX Designer",
    projectName: "Peak Quest",
    projectRole: "Research Lead",
    currentRate: "No rate set",
    totalHours: '0:09:23', 
    totalAmount: '0.00',
  },
  {
    id: 3,
    avatar: "https://i.pravatar.cc/150?img=1",
    name: "Vansh Saini", // Member Name
    role: "Social Media Strategist", // Member Role
    projectName: "Sky Grid",         // Project Name
    projectRole: "Worked Desk 1",    // Project Role
    currentRate: "No rate set",
    totalHours: '6:18:00', 
    totalAmount: '0.00',
  },
  {
    id: 4,
    avatar: "https://i.pravatar.cc/150?img=2",
    name: "Ansh Jain",
    role: "UI/UX Designer",
    projectName: "Peak Quest",
    projectRole: "Research Lead",
    currentRate: "No rate set",
    totalHours: '0:09:23', 
    totalAmount: '0.00',
  }
];
